import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import heroBg from '../assets/1.jpg'; // Hero background image

const Career = () => {
  return (
    <div className="w-full">
      {/* Hero Section */}
      <div
        className="w-full h-[400px] md:h-[300px] bg-cover bg-center flex flex-col justify-center px-6"
        style={{ backgroundImage: `url(${heroBg})` }}
      >
        <motion.h1
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1 }}
          className="text-white text-4xl md:text-5xl font-bold drop-shadow-lg"
        >
          Career
        </motion.h1>
        <motion.div
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="text-white mt-2 text-lg"
        >
          <Link to="/" className="underline hover:text-gray-200">Home</Link> / Career
        </motion.div>
      </div>

      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold mb-10 text-center text-red-600">Apply for a Position</h2>

        <form className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-white p-6 sm:p-10 rounded-xl shadow-xl">
          <div className="md:col-span-2">
            <input
              type="text"
              placeholder="Application for the post of"
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-400"
            />
          </div>

          <input
            type="text"
            placeholder="Your Name"
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-400"
          />
          <input
            type="email"
            placeholder="Email"
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-400"
          />

          <input
            type="number"
            placeholder="Contact Number"
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-400"
          />
          <textarea
            rows={3}
            placeholder="Address of Communication"
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-400"
          />

          <input
            type="date"
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-400"
          />
          <select className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-400">
            <option value="">Select Sex</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>

          <textarea
            rows={3}
            placeholder="Qualifications (Academic/Technical/Professional)"
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-400 md:col-span-2"
          />
          <textarea
            rows={3}
            placeholder="Organizations served"
            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-400 md:col-span-2"
          />

          <div>
            <label className="block mb-1 font-medium text-gray-700">Upload Your CV</label>
            <input
              type="file"
              accept=".pdf,.doc,.docx"
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-400"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">Upload Passport Photo (1MB)</label>
            <input
              type="file"
              accept="image/*"
              className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-red-400"
            />
          </div>

          <div className="md:col-span-2 flex justify-center mt-4">
            <button
              type="submit"
              className="px-10 py-4 rounded-lg bg-gradient-to-r from-red-500 to-red-700 text-white font-semibold shadow-lg hover:scale-105 transition-transform"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Career;
